import { ConsentApi } from './api';

const config = window.flxConsentConfig ?? {};
export const ConsentClient = new ConsentApi(config);
